var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.462 3.09a.6.6 0 011.076 0l2.412 4.887a.6.6 0 00.452.329l5.396.788a.6.6 0 01.332 1.024l-3.904 3.802a.6.6 0 00-.173.531l.921 5.37a.6.6 0 01-.87.633l-4.825-2.537a.6.6 0 00-.558 0l-4.825 2.537a.6.6 0 01-.87-.632l.92-5.371a.6.6 0 00-.172-.531L2.87 10.118a.6.6 0 01.332-1.024l5.396-.788a.6.6 0 00.451-.329l2.413-4.887z","fill":"#3986ED","stroke":"#3986ED","strokeWidth":"1.2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Star.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = Star;

Star.default = Star;
